import { requestJson } from "../lib/api";

export function getPredictions() {
  return requestJson("/api/predictions");
}

export function savePrediction(fixtureId, payload) {
  return requestJson(`/api/predictions/${encodeURIComponent(fixtureId)}`, {
    method: "PUT",
    body: payload,
  });
}
